// extracted by extract-css-chunks-webpack-plugin
module.exports = {"nodeTitle":"nodeTitle-3PFaS"};